



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'utils/axios';
import AuthService from 'services/AuthService'; // Import the AuthService
import { EventEmitter } from 'events';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';



const authEventEmitter = new EventEmitter();


const Login = () => {

  const { i18n,t } = useTranslation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(AuthService.isAuthenticated());

  const languages = ['bs', 'cr', 'sr'];
  const [currentLangIndex, setCurrentLangIndex] = useState(1);


  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }

  }, [navigate]);

  const setLang = (value) => {
    return languages[value - 1];
  };
  useEffect(() => {
    const handleLogout = () => {
      setIsAuthenticated(false);
    };

    authEventEmitter.on('logout', handleLogout);

    return () => {
      authEventEmitter.off('logout', handleLogout);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const response = async () => {
        try {

          const response = await axios.post("auth-middleware/login", {
            username: email,
            password: password
          });
          return response;
        } catch (error) {
          throw error;
        }
      };


      const r = await response();

      if (r.status == 200) {
        console.log(r.data);
        AuthService.saveToken(r.data.token.value.id);
        AuthService.setUsername(r.data.token.value.owner.username);
        AuthService.setCurrentRoleId(r.data.token.value.owner.roleId);
        AuthService.setLanguage(r.data.token.value.owner.language ?? 1);
        AuthService.storeClaims(r.data.token.value.owner.claims);
        setCurrentLangIndex(r.data.token.value.owner.language ?? 1);
        var lang = setLang(r.data.token.value.owner.language ?? 1);

        i18n.changeLanguage(lang);

        navigate('/dashboard');
      } else {
        toast.error(r.data.message);
      }
    } catch (error) {
      toast.error(t('error_occurred'));
    }
  };

  return (
    <div>
      <br />
      <br />
      <br />
      <br />
      <br />
      {error && <p>{error}</p>}
      <form onSubmit={handleSubmit}>
        <h3 className="Auth-form-title">{t('sign_in')}</h3>

        <div className="mb-3">
          <label>{t('username')}</label>
          <input
            type="test"
            placeholder="Email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label>{t('password')}</label>
          <input
            type="password"
            placeholder="Password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}

          />
        </div>
        <div className="d-grid">
          <button type="submit" className="btn btn-primary">
            {t('login')}

          </button>
        </div>
        <span style={{ margin: '0 10px' }}></span>
        <div className="d-grid">

          {/* <button type="button" className="btn btn-primary" onClick={() => navigate('/register')}>Register</button>*/}
        </div>
      </form>
    </div>
  );
};

export default Login;

